import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Grid } from "@mui/material";

import AppraisalCard from "./AppraisalCard";
import AppraisalAddFormDialog from "./AppraisalAddFormDialog";
import rmsActions from "../../../../actions/rmsActions";
import { getAppraisals, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import FabButton from "../../../Common/Button/FabButton";


const AppraisalList = () => {
    const appCode = useSelector(getRmsAppCode);

    const [addOpen, setAddOpen] = useState(false);
    const appraisals = useSelector(getAppraisals);
    const isLoading = useSelector((state) => isFetching(state, DataTypes.RMS_APPRAISALS));
    const dispatch = useDispatch();

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getAppraisals(appCode));
        }
    }, [dispatch, appCode]);

    const handleAddOpen = () => setAddOpen(true);
    const handleAddClose = () => setAddOpen(false);

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {isLoading && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {!!appraisals?.length &&
                    appraisals
                        .sort((a, b) => a.cycle.end - b.cycle.end)
                        .map((data) => (
                            <Grid item xs={12} key={data.id}>
                                <AppraisalCard appraisal={data} />
                            </Grid>
                        ))}
            </Grid>

            {addOpen && (
                <AppraisalAddFormDialog
                    open={addOpen}
                    onSave={(params) => dispatch(rmsActions.addAppraisal(appCode, params))}
                    onClose={handleAddClose}
                />
            )}

            <FabButton onClick={handleAddOpen} />
        </Container>
    );
};

export default AppraisalList;
